import { DOB_CONTACT_EMAIL } from 'app/core/config';
import StatusCard, { StatusCardState } from 'app/ui_v2/components/status-card/StatusCard';

import { Box, useMediaQuery, useTheme } from '@mui/material';

const getCardState = (type: any): StatusCardState => {
  if (type === 'failed') {
    return 'failed';
  }

  if (type === 'success') {
    return 'success';
  }

  if (type === 'cancel') {
    return 'failed';
  }

  return 'pending';
};

const getTitle = (type: any): string => {
  if (type === 'failed') {
    return 'Failed payment';
  }

  if (type === 'success') {
    return 'Successful payment';
  }

  if (type === 'cancel') {
    return 'Cancelled payment';
  }

  return 'Pending payment';
};

const getContent = (type: any): string | JSX.Element => {
  if (type === 'failed') {
    return (
      <>
        <p>Your payment attempt failed for some reason. Please try again after checking the following:</p>
        <ul>
          <li>Ensure your payment method is valid and has sufficient funds.</li>
          <li>Verify that all payment details (card number, expiration date, and security code) are correct.</li>
        </ul>
        <p>
          If the issue persists, <a href={`mailto:${DOB_CONTACT_EMAIL}`}>contact us</a> for support.
        </p>
      </>
    );
  }

  if (type === 'cancel') {
    return <>Your payment was cancel. If this was a mistake, please try again.</>;
  }

  if (type === 'success') {
    return 'Now you can download the certificate pdf file below.';
  }

  return `Processing payment may take up a few minutes.`;
};

export interface PaymentStatusInfoProps {
  status: any;
}

export default function PaymentStatusInfo(props: PaymentStatusInfoProps) {
  const { status } = props;

  const theme = useTheme();
  const matchesMobile = useMediaQuery(theme.breakpoints.down('tablet'));

  return (
    <Box mt={2}>
      <StatusCard
        title={getTitle(status)}
        content={getContent(status)}
        isLoading={false}
        status={getCardState(status)}
        // button={getButton(status, matchesMobile)}
        isMobile={matchesMobile}
      />
    </Box>
  );
}
